/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureFlag } from './FeatureFlag';
import {
    FeatureFlagFromJSON,
    FeatureFlagFromJSONTyped,
    FeatureFlagToJSON,
} from './FeatureFlag';

/**
 * 
 * @export
 * @interface CustomerModuleView
 */
export interface CustomerModuleView {
    /**
     * 
     * @type {Array<FeatureFlag>}
     * @memberof CustomerModuleView
     */
    enabledFeatures: Array<FeatureFlag>;
    /**
     * 
     * @type {Array<FeatureFlag>}
     * @memberof CustomerModuleView
     */
    offeredFeatures: Array<FeatureFlag>;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerModuleView
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerModuleView
     */
    gambytAdminOnly: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerModuleView
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CustomerModuleView
     */
    moduleId: string;
}

/**
 * Check if a given object implements the CustomerModuleView interface.
 */
export function instanceOfCustomerModuleView(value: object): value is CustomerModuleView {
    if (!('enabledFeatures' in value) || value['enabledFeatures'] === undefined) return false;
    if (!('offeredFeatures' in value) || value['offeredFeatures'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('gambytAdminOnly' in value) || value['gambytAdminOnly'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('moduleId' in value) || value['moduleId'] === undefined) return false;
    return true;
}

export function CustomerModuleViewFromJSON(json: any): CustomerModuleView {
    return CustomerModuleViewFromJSONTyped(json, false);
}

export function CustomerModuleViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerModuleView {
    if (json == null) {
        return json;
    }
    return {
        
        'enabledFeatures': ((json['enabledFeatures'] as Array<any>).map(FeatureFlagFromJSON)),
        'offeredFeatures': ((json['offeredFeatures'] as Array<any>).map(FeatureFlagFromJSON)),
        'enabled': json['enabled'],
        'gambytAdminOnly': json['gambytAdminOnly'],
        'name': json['name'],
        'moduleId': json['moduleId'],
    };
}

export function CustomerModuleViewToJSON(value?: CustomerModuleView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enabledFeatures': ((value['enabledFeatures'] as Array<any>).map(FeatureFlagToJSON)),
        'offeredFeatures': ((value['offeredFeatures'] as Array<any>).map(FeatureFlagToJSON)),
        'enabled': value['enabled'],
        'gambytAdminOnly': value['gambytAdminOnly'],
        'name': value['name'],
        'moduleId': value['moduleId'],
    };
}

